/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : EEDetails.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import React from "react";
import PropTypes from "prop-types";
import { Divider, Paper, Stack, Typography } from "@mui/material";

function EEDetails({ selectedEEDetails }) {

  return (
    <Paper sx={styles.detailsContainer}>
      <Typography sx={styles.heading}>EE Component Details</Typography>
      <Divider sx={styles.divider} />

      <Stack mt={1}>
        <Typography variant="subtitle2" sx={styles.nrDetailsTxt}>
          <span style={styles.txtBold}>Assembly Number: </span>
          {selectedEEDetails?.assembly_number || "-"}
        </Typography>
        <Typography variant="subtitle2" sx={styles.nrDetailsTxt}>
          <span style={styles.txtBold}>Version: </span>
          {selectedEEDetails?.version || "-"}
        </Typography>
        <Typography variant="subtitle2" sx={styles.nrDetailsTxt}>
          <span style={styles.txtBold}>Description: </span>
          {selectedEEDetails?.description || "-"}
        </Typography>
        <Typography variant="subtitle2" sx={styles.nrDetailsTxt}>
          <span style={styles.txtBold}>Supplier: </span>
          {selectedEEDetails?.supplier_name || "-"}
        </Typography>
      </Stack>
    </Paper>
  );
}

EEDetails.propTypes = {
  selectedEEDetails: PropTypes.shape({
    assembly_number: PropTypes.string,
    version: PropTypes.string,
    description: PropTypes.string,
    supplier_name: PropTypes.string,
  }),
};

export default EEDetails;

const styles = {
  detailsContainer: {
    minWidth: "100%",
    border: "1px solid grey",
    px: 2,
    pt: 0.4,
    pb: 2,
    my: 2,
  },
  nrDetailsTxt: {
    textAlign: "start",
  },
  divider: {
    mt: 0.4,
    mb: 1,
  },
};
